import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = { class: "d-flex small fw-medium text-start mt-1" }

import { PropType } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CardImageWithTextUnder',
  props: {
  title: {
    type: String,
    default: 'Title',
  },
  options: {
    type: Object as PropType<{ height: number, width: number }>,
    default: () => ({ height: 120, width: 120 }),
  },
  action: {
    type: Function,
    // eslint-disable-next-line no-void
    default: (event: MouseEvent) => { void event; },
  },
  imageSource: {
    type: String,
    default: 'https://ionicframework.com/docs/img/demos/card-media.png',
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_ion_card = _resolveComponent("ion-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_card, {
      class: "position-relative m-0",
      button: true,
      style: _normalizeStyle(`min-height:${__props.options.height}px; min-width: ${__props.options.width}px;`),
      onClick: _cache[0] || (_cache[0] = (event) => __props.action(event))
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default"),
        _createElementVNode("img", {
          src: __props.imageSource,
          alt: __props.title
        }, null, 8, _hoisted_1)
      ]),
      _: 3
    }, 8, ["style"]),
    _createElementVNode("div", _hoisted_2, _toDisplayString(__props.title), 1)
  ], 64))
}
}

})